import { forwardRef as reactForwardRef } from "react";
import { IconButton, IconButtonProps, useColorModeValue } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";

interface PlusCirlceButtonProps extends Omit<IconButtonProps, "aria-label"> {
  label: string;
}

export default function PlusCirlceButton({ label, disabled, ...props }: PlusCirlceButtonProps) {
  const color = "content.tertiary";
  const bgHover = useColorModeValue("brand.50", "cdsGrey.700");
  const bgColor = useColorModeValue("bg.tertiary", "editableBackgroundGrey.dark");
  return (
    <IconButton
      variant="outline"
      borderStyle="dashed"
      color={color}
      size="sm"
      icon={<FiPlus />}
      borderRadius="full"
      width="28px"
      height="28px"
      minWidth="28px"
      backgroundColor={bgColor}
      _hover={disabled ? {} : { bg: bgHover }}
      aria-label={label}
      disabled={disabled}
      {...props}
    />
  );
}

export const PlusCirlceButtonWithRef = reactForwardRef<HTMLButtonElement, PlusCirlceButtonProps>(
  ({ label, disabled, ...props }, ref) => {
    const color = "content.tertiary";
    const bgHover = useColorModeValue("brand.50", "cdsGrey.700");
    const bgColor = useColorModeValue("bg.tertiary", "editableBackgroundGrey.dark");
    return (
      <IconButton
        ref={ref}
        variant="outline"
        borderStyle="dashed"
        color={color}
        size="sm"
        icon={<FiPlus />}
        borderRadius="full"
        width="28px"
        height="28px"
        minWidth="28px"
        backgroundColor={bgColor}
        _hover={disabled ? {} : { bg: bgHover }}
        aria-label={label}
        disabled={disabled}
        {...(props as any)}
      />
    );
  },
);
